import React from 'react'

import { openSurveyModal } from '../../../actions/profileViewActions'

class ProfileSectionSurvey extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { section, dispatch, profile } = this.props
    const onClick = () => {
      dispatch(openSurveyModal(section.surveyId, profile.id))
    }

    return (
      <a href="javascript:void(0)" onClick={onClick} className="btn btn-gray">
        {section.buttonText ? section.buttonText : 'Contact Us'}
      </a>
    )
  }

  componentDidMount() {
    const { section, dispatch, profile } = this.props
    const fragmentId = window.location.hash.substr(1)

    if (fragmentId && fragmentId === section.fragmentId) {
      dispatch(openSurveyModal(section.surveyId, profile.id))
    }
  }
}

export default ProfileSectionSurvey
